import { ScrollPanel } from 'primereact/scrollpanel'
import React, { useEffect, useState } from 'react'
import frame from '../../../images/icon-2/Frame.svg'
import { PiUserCircle } from "react-icons/pi";
import { IoInformationCircleOutline, IoLocationOutline } from "react-icons/io5";
import { AiOutlineMail } from "react-icons/ai";
import { Form } from 'react-bootstrap';
import { FaSpinner } from 'react-icons/fa';
import AdminCreatorNav from './AdminTaskDeatils/AdminCreatorNav';
import DashboardFooter from '../../Common/DashboardFooter';
const AdminCreatorProfile = (props) => {
    const [notification, setNotification] = useState([])
    useEffect(() => {
        if (props.data) {

            setNotification(props.data?.notification ? props.data?.notification : [])
        }
    }, [props?.data])


    return (
        <>
            {props.loader.fetch ? <div className='d-flex align-items-center justify-content-center'><FaSpinner className="spin ms-1" style={{ fontSize: "40px" }} /></div> :
                <>
                    <ScrollPanel className="custombar2 manage-users content-area pt-2">
                        <div className="main_task_details ps-4 pe-4 pb-4">
                            <AdminCreatorNav data={props?.data} />
                            <div className="account-block  mt-4">
                                <h6>Profile Details</h6>

                                <div className='admin_profile_details '>
                                    <div class="mb-3 row">
                                        <label for="staticEmail" className="col-lg-2 col-md-4 col-12  col-form-label">Name</label>
                                        <div class="col-lg-10 col-md-6 col-12">
                                            <p>{props.data?.name}</p>
                                        </div>
                                    </div>
                                    <div class="mb-3 row">
                                        <span for="staticEmail" className="col-lg-2 col-md-4 col-12 col-form-label ">Contact Phone <span className='tooltipN'><IoInformationCircleOutline /><span className='tooltiptext'>Contact Phone</span></span></span>
                                        <div class="col-lg-10 col-md-6 col-12">
                                            <p>{props.data?.mobileNumber} {props.data?.is_mobile_verified === "1" ? <span class="badge ">Verified</span> : ""}</p>
                                        </div>
                                    </div>
                                    <div class="mb-3 row">
                                        <label for="staticEmail" className="col-lg-2 col-md-4 col-12 col-form-label">Email</label>
                                        <div class="col-lg-10 col-md-6 col-12 ">
                                            <p>{props.data?.email}{props.data?.is_email_verified === "1" ? <span class="badge ">Verified</span> : ""}</p>
                                        </div>
                                    </div>

                                    <div class="mb-3 row">
                                        {/* <label for="staticEmail" className="col-lg-2 col-md-4 col-12 col-form-label">Language</label> */}
                                        {/* <div class="col-lg-10 col-md-6 col-12">
                                        {props?.data?.language_name.length > 0 ? props?.data?.language_name.map((curElem, i) => {

                                            return (
                                                <span key={i}>{curElem.name},</span>
                                            )
                                        }) : ""}
                                    </div> */}
                                    </div>
                                    <div class="mb-3 row">
                                        <label for="staticEmail" class="col-lg-2 col-md-4 col-12 col-form-label">Age</label>
                                        <div class="col-lg-10 col-md-6 col-12">
                                            <p>{props.data?.age}</p>
                                        </div>
                                    </div>
                                    <div class="mb-3 row">
                                        <label for="staticEmail" class="col-lg-2 col-md-4 col-12 col-form-label">Kyc</label>
                                        <div class="col-lg-10 col-md-6 col-12">
                                            <p>{props?.data?.is_kyc_updated === "1" ? <span className="verBadge">Done</span> : <span className="verBadge" style={{ backgroundColor: "rgb(255, 243, 205)", color: "rgb(133, 100, 4)", padding:"4px 10px", borderRadius
                                                :"50px"
                                             }}>Pending</span>}</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="account-block mt-4 mb-3 mb-lg-5">
                                <h6>Notification Settings</h6>
                                <div className="block-white mt-4">
                                    <h6>Notifications</h6>
                                    <div className="notification-cardN">
                                        <div className="notification-card-single">
                                            <div className="notification-card-txt">
                                                <h6>Web push notifications</h6>
                                                <p>Receive push notifications on Your web app.</p>
                                            </div>
                                            <span className="custom-switch">
                                                <input type="checkbox" checked={notification.web_notification === "1"} readOnly />
                                                <span className="checkMark"></span>
                                            </span>
                                        </div>

                                        <div className="notification-card-single">
                                            <div className="notification-card-txt">
                                                <h6>Email notifications</h6>
                                                <p>Receive email updates.</p>
                                            </div>
                                            <span className="custom-switch">
                                                <input type="checkbox" checked={notification.email_notification === "1"} readOnly />
                                                <span className="checkMark"></span>
                                            </span>
                                        </div>

                                        <div className="notification-card-single">
                                            <div className="notification-card-txt">
                                                <h6>SMS notifications</h6>
                                                <p>Receive updates in Your mobile number.</p>
                                            </div>
                                            <span className="custom-switch">
                                                <input type="checkbox" checked={notification.sms_notification === "1"} readOnly />
                                                <span className="checkMark"></span>
                                            </span>
                                        </div>

                                        <div className="notification-card-single">
                                            <div className="notification-card-txt">
                                                <h6>Whatsapp notifications</h6>
                                                <p>Receive updates in your whatsapp number.</p>
                                            </div>
                                            <span className="custom-switch">
                                                <input type="checkbox" checked={notification.whatsapp_notification === "1"} readOnly />
                                                <span className="checkMark"></span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </ScrollPanel>
                    <DashboardFooter />
                </>
            }
        </>

    )
}

export default AdminCreatorProfile
